export default "__VITE_ASSET__CNEKGsKa__"